import React from 'react';
import { fill, initials } from './labels';

var VISIBLE_ROWS = 5;

// Participant table for one expanded hour. Completion time is plain text — a badge on
// every row carries no signal (PE-440 defect 4).
export default function ParticipantTable({ participants, expanded, onShowAll, labels }) {
  var rows = expanded ? participants : participants.slice(0, VISIBLE_ROWS);
  var hidden = participants.length - rows.length;

  return (
    <div className="ehc-monitoring__participants">
      <table className="table table-hover table-sm mb-0 ehc-monitoring__table">
        <thead>
          <tr>
            <th className="ehc-monitoring__col-num">{labels.number}</th>
            <th>{labels.participant}</th>
            <th>{labels.company}</th>
            <th className="ehc-monitoring__col-time">{labels.completed_at}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(function (participant, index) {
            return (
              <tr key={participant.id}>
                <td className="text-muted">{index + 1}</td>
                <td>
                  <div className="ehc-monitoring__person">
                    <span className="ehc-monitoring__avatar">{initials(participant.name)}</span>
                    <span className="ehc-monitoring__person-names">
                      <span className="ehc-monitoring__person-name">{participant.name || '—'}</span>
                      <span className="ehc-monitoring__person-eid">
                        {participant.employee_id
                          ? fill(labels.employee_id, { id: participant.employee_id })
                          : labels.employee_id_missing}
                      </span>
                    </span>
                  </div>
                </td>
                <td>{participant.company || '—'}</td>
                <td className="ehc-monitoring__time">{participant.completed_at}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {hidden > 0 && (
        <button type="button" className="btn btn-link ehc-monitoring__more" onClick={onShowAll}>
          <i className="zmdi zmdi-chevron-down" />
          {fill(labels.show_more, { count: hidden })}
        </button>
      )}
    </div>
  );
}
